import { SectionIIRow } from '@/features/dashboard/tfg/types/TfgDeklaracjaPreviewDto.ts';
import DeklaracjaSectionTable from '@/features/dashboard/tfg/components/DeklaracjaSectionTable.tsx';

const formatInt = (value: number) => value.toLocaleString('pl-PL');

interface DeklaracjaSectionIIProps {
  rows: SectionIIRow[];
  /** Section II total — UFG field 97. */
  total: number;
}

const DeklaracjaSectionII = ({ rows, total }: DeklaracjaSectionIIProps) => (
  <DeklaracjaSectionTable<SectionIIRow>
    title="Dział II — Zarachowanie"
    subtitle="Składka z tytułu rozwiązanych lub zmienionych umów, podlegająca zarachowaniu (pola 61–96, suma w polu 97)."
    rows={rows}
    getPkt={(row) => row.pkt}
    getTiming={(row) => row.paymentTiming}
    fieldNumberBase={61}
    makeEmptyRow={(pkt, paymentTiming) => ({
      pkt,
      paymentTiming,
      liczbaUmow: 0,
      liczbaPodroznych: 0,
      zarachowanie: 0,
    })}
    dataColumns={[
      {
        header: 'Liczba umów rozwiązanych lub zmienionych',
        align: 'right',
        render: (row) => formatInt(row.liczbaUmow),
      },
      {
        header:
          'Liczba podróżnych, objętych rozwiązanymi lub zmienionymi umowami',
        align: 'right',
        render: (row) => formatInt(row.liczbaPodroznych),
      },
      {
        header:
          'Łączna wysokość wcześniej odprowadzonych składek należnych do zarachowania na poczet aktualnej składki (w zł)',
        align: 'right',
        render: (row) => formatInt(row.zarachowanie),
      },
    ]}
    totalLabel="Razem zarachowanie (pole 97)"
    totalValue={formatInt(total)}
  />
);

export default DeklaracjaSectionII;
